export default __webpack_public_path__ + "static/submit-btn-d0c1e20b8fa82ad6d14042d4abbeb925.svg";